import { ControlOptions } from "leaflet";
import { useMap } from "react-leaflet";
import { GeopuntLocation } from "types/types";
import { MapControlBase } from "../utils/MapControlBase";
import { SearchAutocomplete } from "./SearchAutocomplete";

interface Props extends ControlOptions {}

export function SearchControl(props: Props) {
  const { ...controlOptions } = props;
  const map = useMap();
  function onSelectLocation(location: GeopuntLocation) {
    map.flyToBounds(
      [
        [
          location.BoundingBox.LowerLeft.Lat_WGS84,
          location.BoundingBox.LowerLeft.Lon_WGS84,
        ],
        [
          location.BoundingBox.UpperRight.Lat_WGS84,
          location.BoundingBox.UpperRight.Lon_WGS84,
        ],
      ],
      {
        maxZoom: 20,
      }
    );
  }
  return (
    <MapControlBase {...controlOptions}>
      <SearchAutocomplete onSelectLocation={onSelectLocation} />
    </MapControlBase>
  );
}
